import React from 'react';
import logo from '../../assets/mishqah-logo.png';
import './Footer.scss';
import TexturePattern from '../../components/TexturePattern/TexturePattern';
import { FaInstagram, FaWhatsapp} from "react-icons/fa";
import { Link } from 'react-router-dom';
import call from '../../assets/footer/calling.png';
import time from '../../assets/footer/time.png';
import location from '../../assets/footer/location.png';

const Footer = () => {

    const footerMenu = [
        {
            name: 'Home',
            link: '/',
        },
        {
            name: 'About Us',
            link: '/about',
        },
        {
            name: 'Services Offered',
            link: '/singleservice',
        },
        {
            name: 'Contact Us',
            link: '/contact',
        }
    ];

    const footerContacts = [
        {
            'title': 'Phone Number',
            'info': (
                <>
                    <a href="tel:+27649144852" style={{display: 'block', color: 'inherit', textDecoration: 'underline'}}>0649144852</a>
                    <a href="tel:+27217039149" style={{display: 'block', color: 'inherit', textDecoration: 'underline'}}>0217039149</a>
                </>
            ),
            'icon': call
        },
        {
            'title': 'Opening Hours',
            'info': (
                <>
                    Mon-Fri 8:30 to 12:00 - 14:00 to 18:00  <br />
                    Saturdays 9:00 to 12:00 <br />
                    Closed on Sundays and public holidays
                </>
            ),
            'icon': time
        },
        {
            'title': 'Clinic Address',
            'info': '280 Ottery Road, Southern Suburbs, Ottery, Cape Town',
            'icon': location,
            'address': '280 Ottery Road, Southern Suburbs, Ottery, Cape Town, South Africa'
        }
    ]

    return (
        <footer className='pt-100 pb-70 position-relative' role="contentinfo">
            <TexturePattern isFooter={true} />
            <div className="footer-separator"></div>
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-5">
                        <div className="footer-logo">
                            <div className="logo-container">
                                <img src={logo} alt="Dr Mishqah Dollie Dental Practice Logo" />
                            </div>
                        </div>
                        <p>Dr Mishqah Dollie is a top-rated local practice for all types of dentistry in Ottery, Cape Town. We provide comprehensive dental care with a focus on patient comfort and modern treatment options.</p>

                        <div className="social-logo">
                            <p>Follow us on</p>
                            <ul>
                                <li>
                                    <a href="https://www.instagram.com/drdollie_dentist/" 
                                       target="_blank" 
                                       rel="noopener noreferrer"
                                       aria-label="Follow Dr Mishqah Dollie on Instagram">
                                        <FaInstagram/>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://wa.me/27649144852" 
                                       target="_blank" 
                                       rel="noopener noreferrer"
                                       aria-label="Contact Dr Mishqah Dollie on WhatsApp">
                                        <FaWhatsapp/>
                                    </a>
                                </li>
                            </ul>
                            <div style={{ marginTop: '16px' }}>
                                <a className="theme-btn" 
                                   href="https://www.google.com/search?sca_esv=a56679814246b468&rlz=1C1GCEU_enZA923ZA923&sxsrf=AE3TifMS9Fjn-AhqcmcYTGNjiFUyfhkNlA:1750883730935&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-ExYl9rvxnlt7NdxU1lbF7HDBDmnpCf9vEGuJgEPSHg0emLaLN3_Zb9V4hMnYOsoqWH6vnvKV39sE8H0QIkhf0to1BezVMxAgK7pd9gV7XKn22ZOJ3w%3D%3D&q=Dr+Mishqah+Dollie+Reviews&sa=X&ved=2ahUKEwiQ6syWto2OAxWpXKQEHdcWMaQQ0bkNegQIJRAE&biw=1536&bih=695&dpr=1.25" 
                                   target="_blank" 
                                   rel="noopener noreferrer"
                                   aria-label="Leave a Google Review for Dr Mishqah Dollie">
                                    Leave a Google Review
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-2">
                        <nav className="footer-link" role="navigation" aria-label="Footer navigation">
                            <h3>Quick Links</h3>
                            <ul>
                                {
                                    footerMenu.map((singleMenu, index) => (
                                        <li key={index}>
                                            <Link to={singleMenu.link}>{singleMenu.name}</Link>
                                        </li>
                                    ))
                                }
                            </ul>
                        </nav>
                    </div>
                    <div className="col-lg-4 col-md-5">
                        <div className="footer-contact">
                            <h3>Contact & Information</h3>

                            {
                                footerContacts.map((footerContact, index) => {
                                    return  <div className="contact-list" key={index}>
                                                <div className="contact-icon">
                                                    <img src={footerContact.icon} alt={`${footerContact.title} icon`} />
                                                </div>
                                                <div className="contact-text">
                                                    <p>{footerContact.title}</p>
                                                    <h5>
                                                        {footerContact.phone ? (
                                                            <a href={`tel:${footerContact.phone}`} aria-label={`Call ${footerContact.title}`}>
                                                                {footerContact.info}
                                                            </a>
                                                        ) : footerContact.address ? (
                                                            <a href={`https://maps.google.com/?q=${encodeURIComponent(footerContact.address)}`} 
                                                               target="_blank" 
                                                               rel="noopener noreferrer"
                                                               aria-label={`View ${footerContact.title} on Google Maps`}>
                                                                {footerContact.info}
                                                            </a>
                                                        ) : (
                                                            footerContact.info
                                                        )}
                                                    </h5>
                                                </div>
                                            </div>
                                })
                            }
                        </div>
                    </div>
                </div>

                <div className="copyright-area">
                    <div className='copy-text'>
                        <p>
                            &copy; {new Date().getFullYear()} Dr Mishqah Dollie. All Rights Reserved. <span style={{whiteSpace: 'nowrap'}}>Developed and Hosted by <a href="https://www.kaizentech.co.za" target="_blank" rel="noopener noreferrer">Kaizen Technology</a></span>
                        </p>
                    </div>  
                    <div className='copy-links'>
                        <ul>
                            <li><Link to='/'>Terms of Use</Link></li>
                            <li><Link to='/'>Privacy Policy</Link></li>
                        </ul>
                    </div>                          
                </div>
            </div>
        </footer>
    );
};

export default Footer;